import { render, staticRenderFns } from "./BidDetails.vue?vue&type=template&id=3b073591&scoped=true"
import script from "./BidDetails.vue?vue&type=script&lang=js"
export * from "./BidDetails.vue?vue&type=script&lang=js"
import style0 from "./BidDetails.vue?vue&type=style&index=0&id=3b073591&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b073591",
  null
  
)

export default component.exports